<template>
  <div>
    <div class="total-title">
      <span>So gross ist die aktuelle Solidarität:</span>
    </div>
    <div class="section-wrap-full-width bg-error mt-4">
      <div class="w-75 text-white analytics-wrapper">
        <div class="content-center-group">
          <i class="stg st-love-heart-hands-hold-3 align-middle align-middle text-white"></i>
          <h1 class="text-white" v-if="donationReport">{{donationReport.total}}</h1>
          <h1 class="text-white" v-if="!donationReport">0</h1>
          <small v-if="donationReport">mal freut man sich auf den nächsten Besuch<br/>im Lieblingsladen.</small>
          <i class="stg st-space-rocket-flying align-middle text-white"></i>
          <div class="d-flex align-items-center">
            <h1 class="text-white" v-if="donationReport">{{donationReport.totalMoney | toCurrency}}</h1>
            <h1 class="text-white" v-if="!donationReport">0</h1>
          </div>
          <small style="font-size: 16px;">werden gerne extra bezahlt.</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  data: function() {
    return {
      donationReport: null
    };
  },
  mounted: function() {
    let db = firebase.firestore();
    let reportRef = db.collection("report");
    let $this = this;

    reportRef.doc("donation").onSnapshot(function(donationReportSnapshot) {
      $this.donationReport = donationReportSnapshot.data();
    });
  }
};
</script>

<style>
</style>
